import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);
  const [quantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(
    product?.size ? product.size[0] : ""
  );

  if (!product) {
    return <div>Product not found</div>;
  }

  const handleAddToCart = () => {
    if (product.size && product.size.length > 0 && !selectedSize) {
      alert("Please select a size.");
      return;
    }
    addToCart(product.id, quantity, selectedSize);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />

      <div className="product-detail-container">
        <div className="product-detail-wrapper">
          {/* Breadcrumb Navigation */}
          <div className="breadcrumb">
            <Link onClick={toTop} to="/">
              Shop All
            </Link>
            <span className="separator">•</span>
            <Link onClick={toTop} to="/shop">
              New Arrivals
            </Link>
          </div>

          <div className="product-detail-content">
            {/* Left Side - Product Images */}
            <div className="product-images-section">
              <div className="product-images-grid">
                {product.images.map((image, index) => (
                  <div key={index} className="product-image-item">
                    <img src={image} alt={`${product.name} ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>

            {/* Right Side - Product Information */}
            <div className="product-info-section">
              <div className="product-info-sticky">
                {/* Product Title and Price */}
                <div className="product-header">
                  <h1 className="product-title">{product.name}</h1>
                  <div className="product-price">${product.price}</div>
                </div>

                {/* Product Description */}
                <div className="product-description">
                  {Array.isArray(product.description) ? (
                    product.description.map((desc, index) => (
                      <p key={index}>{desc}</p>
                    ))
                  ) : (
                    <p>{product.description}</p>
                  )}
                </div>

                {/* Size Selection */}
                {product.size && product.size.length > 0 && (
                  <div className="product-size-section">
                    <div className="size-header">
                      <span className="size-label">Size: {selectedSize}</span>
                    </div>
                    <div className="size-options">
                      {product.size.map((size) => (
                        <button
                          key={size}
                          className={`size-option ${
                            selectedSize === size ? "selected" : ""
                          }`}
                          onClick={() => setSelectedSize(size)}
                        >
                          {size}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Add to Cart Buttons */}
                <div className="product-actions">
                  <button className="btn-add-to-cart" onClick={handleAddToCart}>
                    ADD TO CART
                  </button>
                </div>

                {/* Store Pickup Info */}
                <div className="store-pickup">
                  <div className="pickup-info">
                    <svg
                      className="check-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <circle
                        cx="8"
                        cy="8"
                        r="7"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="1"
                      />
                      <path
                        d="M5 8l2 2 4-4"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="1.5"
                      />
                    </svg>
                    <div className="pickup-details">
                      <p className="pickup-text">
                        PICKUP AVAILABLE AT AUSTIN - TX - 108AU
                      </p>
                      <p className="pickup-time">Usually ready in 2 hours</p>
                      <button className="check-stores-link">
                        Check availability at other stores
                      </button>
                    </div>
                  </div>
                </div>

                {/* Product Style Number */}
                <div className="product-meta">
                  <p className="style-number">STYLE NO. 104-789</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProductDetail;
